import Vue from 'vue'
import App from './App.vue'
import router from './router'

import './assets/css/common.scss'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/font/iconfont.css'
import locale from 'element-ui/lib/locale/lang/ja'
Vue.config.productionTip = false
Vue.use(ElementUI,{locale});
new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
